import { useStaticQuery, graphql } from 'gatsby';

export const useFlow = () => {
  const { allMdx } = useStaticQuery(graphql`
    query flowQuery {
      allMdx(filter: { fields: { source: { eq: "asc-flow" } } }) {
        nodes {
          frontmatter {
            title
            anchor
            description
          }
        }
      }
    }
  `);

  return (
    allMdx?.nodes.map((item) => ({
      ...item.frontmatter
    })) || []
  );
};
